import licenseModule from '../../license.module';

export default licenseModule.component('licenseConsoleNewServerPerpetual', {
    template: require('./licenseConsoleNewServerPerpetual.component.html'),
    controller: [
        'entitlementConstants',
        licenseConsoleNewServerPerpetualComponent
    ],
    bindings: {
        summaryDeviceIdTotal: '<',
        summaryPremiumUserIdTotal: '<',
        summaryDeviceIdUsage: '<',
        summaryPremiumUserIdUsage: '<',
        licenseMaxUsers: '<',
        licenseMaxDevices: '<',
        onlyPerpetual: '<',
        callback: '&'
    }
});

function licenseConsoleNewServerPerpetualComponent(entitlementConstants) {
    var vm = this;
    vm.devicesLabel = entitlementConstants.devices;
    vm.platformUsersLabel = entitlementConstants.platformUsers;
    vm.platformUserLabel = entitlementConstants.platformUser;

    var newMaxusers = 0;
    var newMaxDevices = 0;

    vm.$onInit = function() {
        vm.licenseMaxDevices = 0;
        vm.licenseMaxUsers = 0;
        vm.min = 1;
    };
    vm.changes = function() {
        if (
            (vm.licenseMaxUsers !== undefined &&
                vm.licenseMaxUsers != newMaxusers) ||
            vm.licenseMaxUsers == 0 ||
            ((vm.licenseMaxDevices !== undefined &&
                vm.licenseMaxDevices != newMaxDevices) ||
                vm.licenseMaxDevices == 0)
        ) {
            var value = {
                license: {
                    maxUsers: vm.licenseMaxUsers,
                    maxDevices: vm.licenseMaxDevices
                }
            };

            vm.callback({ value: value });
        }
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-console-new-server-perpetual/licenseConsoleNewServerPerpetual.component.js